import styled from 'styled-components'
import { Test } from '../../models/Test'

type Props = {
  test: Test
  handleClick?: () => void
}

function TestBox(props: Props) {
  return (
    <JobTestCard onClick={() => props.handleClick && props.handleClick()}>
      {props.test.isComplete && <Complete>완료</Complete>}
      <TestName>{props.test.name}</TestName>
      <TestSubName>{props.test.subName}</TestSubName>
      {props.test.isComplete ? (
        <Go>결과 확인하기</Go>
      ) : (
        <Go>테스트 하러가기</Go>
      )}
    </JobTestCard>
  )
}

const JobTestCard = styled.div`
  padding: 35px;
  margin: 0 100px;
  background-color: cornflowerblue;
  /* border: 1px solid #aaa; */
  color: white;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: deepskyblue;
    color: black;
  }
  &:active {
    background-color: dodgerblue;
    color: black;
  }
`

const TestName = styled.div`
  font-size: 1.3rem;
  text-align: center;
  padding-bottom: 10px;
`

const TestSubName = styled.div`
  font-size: 1.05rem;
  text-align: center;
`
const Go = styled.div`
  padding-top: 20px;
  font-size: 1rem;
  text-align: center;
  text-decoration: underline;
`

const Complete = styled.div`
  position: absolute;
  left: 5px;
  top: 5px;
  padding: 3px 20px;
  background-color: darkblue;
  color: white;
  font-size: 0.9rem;
`

export default TestBox
